// TODO: Move this code into the module when ni.js is deprecated

(function($) {
    window.initMobileMenu = function() {

        $('#mainMenuToggle').data('exclusive_popover', {$tip: $('#top-navi')});

        function show() {
            $('#mainMenuToggle').trigger($.Event('show.bs.popover'));
            $('#top-navi').show().addClass('in');
            $('#hamburgerIcon').addClass('in');
        }

        function hide() {
            $('#top-navi').hide().removeClass('in');
            $('#hamburgerIcon').removeClass('in');
        }

        $('#mainMenuToggle')
            .click(function () {
                if ($('#top-navi').hasClass('in')) {
                    hide();
                } else {
                    show();
                }
                return false;
            })
            .exclusivePopover({group: 'metanav', onHide: hide});

    };
})(jQuery);
